export default __webpack_public_path__ + "static/media/landingPage.f6fcb2ab.jpeg";